export enum DateFormat {
    date = 'MMM DD, YYYY',
    dateWithTime = 'MMM DD, YYYY h:mm A',
}
